import { createBooleanLocalStorageState } from './manager';

export const highlightOnlineOnlyDaysGlobalState = createBooleanLocalStorageState('highlightOnlineOnlyDays', true);
